import { render } from "./DatePicker.vue?vue&type=template&id=37e051f6&scoped=true"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"

import "./DatePicker.vue?vue&type=style&index=0&id=37e051f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37e051f6"

export default script